<script>
// インクルードするCSS定義コンポーネント
// import Ress from './module/Ress.vue'
// import ScrollbarCSS from './module/ScrollbarCSS.vue'
// import BaseCSS from './module/BaseCSS.vue'
import MainCSS from './module/MainSPCSS.vue'
import ModuleDocument from './module/ModuleDocument.vue'

// コンポーネントと認識させるためにexport default は必要
export default {

}
</script>
